import axios from 'axios';
import React, { createContext, useState, useEffect, useContext } from 'react';

// 1. Create the context
const SettingsContext = createContext();

// 2. Create the provider component
export const SettingsProvider = ({ children }) => {

  const renderHTML = (escapedHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });

  const [settings, setSettings] = useState(null); // Initially, set to null or {} depending on your use case
  const [loading, setLoading] = useState(true);   // To track loading state
  const [error, setError] = useState(null);       // To handle errors


  // Fetch data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://mv-tyre.demo-customproject.com/backend/api/get-settings'); // Replace with your API URL
        const data = await response.json();
        // console.log(data);
        setSettings(data.data); // Set the settings data to state
      } catch (err) {
        setError('Failed to fetch settings');
      } finally {
        setLoading(false); // Set loading to false after the data is fetched
      }
    };

    fetchData();
  }, []); // Empty dependency array means this will run only once on mount


  const [services, setServices] = useState(null);

  const getServ = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}get-services`);
      setServices(res.data.data)
    } catch (err) {
      console.log('Error Content all services', err)
    }
  }

  useEffect(() => {
    getServ();
  }, [])


  return (
    <SettingsContext.Provider value={{ settings, loading, error, renderHTML, services }}>
      {children}
    </SettingsContext.Provider>
  );
};


export const useSettings = () => {
  return useContext(SettingsContext);
};